"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
const ConfigServiceLive_1 = require("./ConfigServiceLive");
const ConfigServiceStub_1 = require("./ConfigServiceStub");
class ConfigService {
    static create(useStub) {
        if (useStub) {
            return new ConfigServiceStub_1.ConfigServiceStub();
        }
        return new ConfigServiceLive_1.ConfigServiceLive();
    }
}
exports.ConfigService = ConfigService;
//# sourceMappingURL=ConfigService.js.map